"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const styles_1 = require("../styles");
function Shimmer() {
    const { aboveMd } = (0, useWindowWidth_1.default)();
    return (react_1.default.createElement(styles_1.LoadingContainer, { "data-testid": "Loading" },
        react_1.default.createElement(styles_1.LoadingContent, null,
            react_1.default.createElement(styles_1.ContentHeader, null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            react_1.default.createElement(styles_1.ContentText, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null)))),
        aboveMd && (react_1.default.createElement(styles_1.LoadingSidebar, null,
            react_1.default.createElement(styles_1.SidebarProfilePic, null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            react_1.default.createElement(styles_1.SidebarInfo, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null)))))));
}
exports.default = Shimmer;
//# sourceMappingURL=Shimmer.js.map